import { Injectable } from '@angular/core';
import { BehaviorSubject, Observable, Subject } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class LocalStorageService {
  private storageSub= new Subject<String>();
  
  constructor() {}
  public saveData(key: string, value: string) {
    localStorage.setItem(key, value);
    this.storageSub.next('changed');
  }

  public getData(key: string) {
    return localStorage.getItem(key);
  }
  public removeData(key: string) {
    localStorage.removeItem(key);
    this.storageSub.next('changed');
  }

  public clearData() {
    localStorage.clear();
  }

  public watchStorage(): Observable<any> {
    return this.storageSub.asObservable();
  }
  
}
